import { Building2, FileText, Package, SlidersHorizontal, Store } from 'lucide-vue-next'
import type { FunctionalComponent } from 'vue'

/**
 * Položka hlavnej navigácie.
 *
 * `roles` skryje položku pred tým, kto na ňu nemá právo. Nie je to
 * autorizácia — tú robí server pri každom dopyte — je to poriadok v menu.
 */
export interface NavigationItem {
	readonly routeName: string
	readonly labelSk: string
	readonly icon: FunctionalComponent
	readonly roles?: readonly string[]
}

export interface NavigationGroup {
	readonly labelSk: string | null
	readonly items: readonly NavigationItem[]
}

/**
 * Štruktúra sidebaru.
 *
 * Poradie kopíruje pracovný postup: konfigurácia → ponuka → objednávka.
 * Administrácia je oddelená, lebo do nej chodí iný človek (importér).
 */
export const NAVIGATION: readonly NavigationGroup[] = [
	{
		labelSk: null,
		items: [
			{ routeName: 'configurator', labelSk: 'Konfigurátor', icon: SlidersHorizontal },
			{ routeName: 'quotes', labelSk: 'Ponuky', icon: FileText },
			{ routeName: 'orders', labelSk: 'Objednávky', icon: Package },
			{
				routeName: 'my-company',
				labelSk: 'Moja firma',
				icon: Store,
				roles: ['PARTNER_ADMIN'],
			},
		],
	},
	{
		labelSk: 'Administrácia',
		items: [
			{
				routeName: 'admin-partners',
				labelSk: 'Partneri',
				icon: Building2,
				roles: ['TENANT_ADMIN', 'TENANT_SALES'],
			},
			{ routeName: 'admin-price-lists', labelSk: 'Cenníky', icon: FileText, roles: ['TENANT_ADMIN'] },
		],
	},
]
